<template>
  <div id="puzzle-content">
    <div id="draw">
      <div class="svg-wrapper" v-on:click.capture.prevent></div>
    </div>
    <!-- This puzzle can be found <a href="https://www.cs.ubc.ca/~amon/draw/draw.html">here</a>. -->
  </div>
</template>

<script>
import {draw} from '@/assets/draw/draw.js'

export default {

  mounted () {
    // console.log('mounted')
    draw()
  },
}
</script>

<style>

/* main.css */

#interactive-content {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

#draw {
  text-align: center;
  margin: 0 20px;
}

.svg-wrapper {
  font-size: 0;
  display: inline-block;
	position: relative;
	vertical-align: middle; 
	overflow: hidden; 
  width: 100%;
}

#drawn path {
  fill: none;
  /* stroke: #969696; */
  stroke-width: 6px; 
  stroke-linecap: round;
}

#drawing path {
  fill: none;
  /* stroke: #969696; */
  stroke-width: 6px; 
  stroke-linecap: round;
}

#draw .feedback {
  width: 100%;
  margin: 0 auto;
  background-color: #969696;
  text-align: center;
  pointer-events: none;
  -webkit-transition: background-color 0.2s linear;
  -moz-transition: background-color 0.2s linear;
  -o-transition: background-color 0.2s linear;
  -ms-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

#draw .feedback .feedback-text {
  font-family: 'MyriadPro', 'Helvetica Neue', 'HelveticaNeue', Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 40pt;
  color: #fff;
}


/* ui.css */

.header {
    border: 0px;
    fill: #666;
    font-size: 30px;
    font-family: 'MyriadProCond', sans-serif;
}

.header rect.restart {
    fill: #bbb;
    cursor: pointer;
}

.header rect.restart.disable {
    /* fill: #f9f9f9; */
    fill: #d8d8d8;
    cursor: default;
}

.header .level .current {
    fill: rgb(44, 182, 228);
}

.header rect.feedback {
    fill: #969696;
    stroke: none;
}

.header text.feedback {
    fill: white;
    font-size: 56px;
    font-weight: bold;
    text-anchor: middle;
}

.header tspan.feedback.shape {
    fill: #6ce;
}

.main .mainspace {
    fill: #f9f9f9;
    stroke: #969696;
    stroke-width: 1;
}

.border {
    fill: #444;
}


svg .outline {
    stroke: rgb(127, 212, 255);
    stroke-width: 50px;
    fill: none;
}

svg text {
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
}

.border text {
    fill: white;
    font-family: 'MyriadProCond', sans-serif;
    font-weight: bold;
    text-anchor: middle;
}

.border text.label {
    font-size: 36pt;
}

.border text.access {
    font-size: 40pt;
}

.border text.access.granted {
    fill: #6ce;
}
.border text.access.denied {
    fill: #d6c;
}

.border text.detector {
    font-size: 18pt;
}

.border.rules {
    fill: none;
    stroke: #666;
    stroke-width: 15px;
}

.border.rules .pass {
    stroke: #6ce;
}

.border .detect {
    fill: none;
    stroke: #d6c;
    stroke-width: 13px;
}

.border .detect.allowed {
    stroke: #6ce;
}


</style>

<!--
<script src="@/assets/draw/d3.v4.min.js"></script>
<script src="@/assets/draw/ui.js"></script>
<script src="@/assets/draw/draw.js"></script>
<script src="@/assets/draw/convert.js"></script>
<script src="@/assets/draw/neataptic.js"></script>
<script src="@/assets/draw/shape.js"></script>

-->